var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"font-weight-medium text-decoration-none me-2",attrs:{"to":{ name: 'ReportBranch' }}},[_c('v-tooltip',{attrs:{"color":"#212121","top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"color":"primary","icon":""}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v(_vm._s(_vm.icons.mdiArrowLeftBold))])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.$t('back')))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }